import { useAttributeReviewFieldMappingsQuery } from "@/graphql/generated";

export function useKindOptions(sessionId: string) {
  const { data = [] } = useAttributeReviewFieldMappingsQuery(
    { sessionId },
    {
      select: (payload) =>
        payload.attributeReviewFieldMappings?.kindOptions ?? [],
      staleTime: Infinity,
      enabled: Boolean(sessionId),
    },
  );
  return data;
}
